import { Component } from '@angular/core';
import { CheckoutDeliveryStatusComponentDef } from '@df/checkout/checkout-delivery-status.component.def';
import { App } from '@df/core/app';
import { ToAddressPipeService } from '@df/ui/common/to-address.pipe';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { CheckoutFormComponent } from './checkout-form.component';

@Component({
    selector: 'checkout-delivery-method-status',
    templateUrl: './checkout-delivery-method-status.html',
    standalone: true,
    imports: [PriceComponent, TranslatePipe]
})
export class CheckoutDeliveryMethodStatusComponent extends CheckoutDeliveryStatusComponentDef {
    constructor(checkoutFormComponent: CheckoutFormComponent, toAddressPipe: ToAddressPipeService, app: App) {
        super(checkoutFormComponent, toAddressPipe, app);
    }
}
